












































































































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import ProductState from '@/components/Products/ProductState.vue';
import DepositOverdraftInterestSettings from '@/models/Products/ProductSettings/DefaultSettings/OverdraftInterest/DepositOverdraftInterestSettings';
import DepositOverdraftInterestSettingsEditDialog from '@/components/Products/ProductSettings/DefaultSettings/OverdraftInterest/DepositOverdraftInterestSettingsEditDialog.vue';
import InterestRateType from '@/models/Products/InterestRateType';
import PeriodType from '@/models/Shared/PeriodType';
import EntityType from '@/models/Shared/EntityType';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'DepositOverdraftInterestSettingsRead', components: { ProductState, DepositOverdraftInterestSettingsEditDialog } })
export default class extends SaascadaVueFieldGroup {

    InterestRateType = InterestRateType;
    PeriodType = PeriodType;
    EntityType = EntityType;
    PermissionUtils = PermissionUtils;

    @Prop({required: true })
    settings: DepositOverdraftInterestSettings;

    @Prop({required: true})
    entityType: EntityType;

    get settingsAvailable() {
        return (this.settings !== undefined);
    }

    get cumulativeRateCalculationText() {
        // A text representation of the cumulative rate calculation
        return `${this.settings.rateSourceIdentifier.entityName} ${this.rateSourceRate}% + ${this.$t('pageText.products.fields.rateValue')} ${this.settings.rateValue}%`;
    }

    get rateSourceRate() {
        // This is not currently provided in the API so calculate it manually
        return this.settings.cumulativeRateValue - this.settings.rateValue;
    }

}
